const clamp = (value, min, max) => Math.min(max, Math.max(min, value));

const buildSoloStatement = (artworks) => {
  if (!artworks.length) return [];
  if (artworks.length === 1) {
    return [{ id: artworks[0].id, x: 20, y: 12, w: 60, h: 76 }];
  }
  const first = { id: artworks[0].id, x: 7, y: 14, w: 44, h: 70 };
  const rightColumn = artworks.slice(1).map((artwork, index, list) => ({
    id: artwork.id,
    x: 58,
    y: 12 + index * (72 / Math.max(list.length, 1)),
    w: 24,
    h: clamp(62 / Math.max(list.length, 1), 15, 26),
  }));
  return [first, ...rightColumn];
};

const buildGalleryRow = (artworks) => {
  if (!artworks.length) return [];
  const gap = 3;
  const count = artworks.length;
  const width = clamp((100 - gap * (count - 1)) / count, 14, 28);
  const totalWidth = width * count + gap * (count - 1);
  const startX = (100 - totalWidth) / 2;
  return artworks.map((artwork, index) => ({
    id: artwork.id,
    x: startX + index * (width + gap),
    y: 23,
    w: width,
    h: 48,
  }));
};

const buildSalonGrid = (artworks) => {
  if (!artworks.length) return [];
  const columns = artworks.length <= 4 ? 2 : artworks.length <= 6 ? 3 : 4;
  const rows = Math.ceil(artworks.length / columns);
  const gapX = 3;
  const gapY = 4;
  const width = clamp((100 - gapX * (columns - 1)) / columns, 16, 24);
  const height = clamp((76 - gapY * (rows - 1)) / rows, 18, 32);
  const totalWidth = width * columns + gapX * (columns - 1);
  const startX = (100 - totalWidth) / 2;
  const startY = 12;
  return artworks.map((artwork, index) => {
    const col = index % columns;
    const row = Math.floor(index / columns);
    return {
      id: artwork.id,
      x: startX + col * (width + gapX),
      y: startY + row * (height + gapY),
      w: width,
      h: height,
    };
  });
};

export const exhibitionWallPresets = [
  {
    id: 'solo-statement',
    label: 'Solo Statement',
    description: 'One hero work with supporting pieces.',
    build: buildSoloStatement,
  },
  {
    id: 'gallery-row',
    label: 'Gallery Row',
    description: 'A clean horizontal wall for quick presentation.',
    build: buildGalleryRow,
  },
  {
    id: 'salon-grid',
    label: 'Salon Grid',
    description: 'Compact multi-work arrangement for 4 to 8 artworks.',
    build: buildSalonGrid,
  },
];

export const defaultFrameStyles = [
  { id: 'white', label: 'White Frame', border: '#F8FAFC', shadow: 'rgba(15, 23, 42, 0.18)', accent: '#E2E8F0' },
  { id: 'black', label: 'Black Frame', border: '#111827', shadow: 'rgba(15, 23, 42, 0.24)', accent: '#374151' },
  { id: 'wood', label: 'Wood Frame', border: '#8B5E3C', shadow: 'rgba(120, 53, 15, 0.24)', accent: '#C08A5B' },
  { id: 'gold', label: 'Gold Frame', border: '#B88917', shadow: 'rgba(146, 64, 14, 0.22)', accent: '#F5D77A' },
];

export const wallPalettes = [
  { id: 'ivory', label: 'Ivory Wall', value: '#F8F5EE' },
  { id: 'gallery-white', label: 'Gallery White', value: '#FBFBF8' },
  { id: 'sage', label: 'Sage', value: '#E8F2EC' },
  { id: 'slate', label: 'Slate', value: '#E9EEF6' },
  { id: 'charcoal', label: 'Charcoal', value: '#1F2937' },
];

export const buildFramesFromPreset = (presetId, artworks) => {
  const preset = exhibitionWallPresets.find((item) => item.id === presetId) || exhibitionWallPresets[0];
  return preset.build(artworks);
};
